import React, { useEffect, useState, useRef } from "react";
import './AdidasProducts.css';
import Item from "../Item/Item";

const AdidasProducts = () => {
  const [adidasProducts, setAdidasProducts] = useState([]);
  const productsListRef = useRef(null);

  useEffect(() => {
    fetch('/api/adidasproducts')
      .then((response) => response.json())
      .then((data) => setAdidasProducts(data.slice(0, 10)))
      .catch((error) => console.error('Error fetching Adidas products:', error));
  }, []);

  const scroll = (scrollOffset) => {
    if (productsListRef.current) {
      const itemWidth = productsListRef.current.querySelector('.carousel-item-container').offsetWidth;
      const newScrollOffset = (itemWidth + 24) * 3 * Math.sign(scrollOffset); // Scroll by 3 items
      productsListRef.current.scrollBy({ left: newScrollOffset, behavior: 'smooth' });
    }
  };

  return (
    // The main section is full-width
    <section className="product-carousel"> 
      <div className="brand-ribbon">
          <div className="brand-ribbon__track">
              {Array(10).fill().map((_, i) => (
                  <span key={i} className="brand-ribbon__text">ADIDAS</span>
              ))}
          </div>
      </div>

      {/* Header is inside a centered .container */}
      <div className="container">
        <div className="product-carousel__header">
          <h2>ADIDAS</h2>
        </div>
      </div>
      
      {/* List wrapper is full-width */}
      <div className="product-carousel__list-wrapper">
        <div className="product-carousel__list" ref={productsListRef}>
          {adidasProducts.length > 0 ? (
            adidasProducts.map((item) => (
              <div className="carousel-item-container" key={item.id}>
                <Item 
                  id={item.id} 
                  name={item.name} 
                  image={item.image} 
                  new_price={item.new_price} 
                  old_price={item.old_price} 
                />
              </div>
            ))
          ) : (
            <div className="spinner-container">
              <div className="spinner"></div>
            </div>
          )}
        </div>
        
        <button className="carousel-button carousel-button--left" onClick={() => scroll(-1)} aria-label="Scroll left">
          {'<'}
        </button>
        <button className="carousel-button carousel-button--right" onClick={() => scroll(1)} aria-label="Scroll right">
          {'>'}
        </button>
      </div>
    </section>
  );
}

export default AdidasProducts;